module.exports = __webpack_public_path__ + "static/after-b7dcc7b5c50067b697bd5c31d7f4382c.png";